import React, { Component } from 'react';
import { Doughnut, Line } from 'react-chartjs-2';
import { Card, CardBody, Label, Input, FormGroup } from 'reactstrap';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { Row, Col, PageHeader, DatePicker, Button, Spin, Modal } from 'antd';
import Card1 from '../../components/Ants/Card/Card1';
import Card2 from '../../components/Ants/Card/Card2';
import Card4 from '../../components/Ants/Card/Card4';
import Card5 from '../../components/Ants/Card/Card5';
import LineDoughnut from '../Dashboard/LineDoughnut';
import MultiColorProgressBar from '../../components/Ants/MultiColorProgressBar';
import 'antd/dist/antd.css';
import { urlapi, token, CheckTokenExp } from '../../config';
import moment from 'moment';

const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandDanger = '#f86c6b';
const brandUnverified = '#000000'
const brandPending = '#ffc107'

// convert Hex to RGBA
function convertHex(hex, opacity) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
    return result;
}


class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.LineDashBoard = this.LineDashBoard.bind(this);
        this.LineFollowData = this.LineFollowData.bind(this);
        this.LineMainChart = this.LineMainChart.bind(this);
        this.onChangedate = this.onChangedate.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCreateExpiredate = this.onCreateExpiredate.bind(this);
        this.zeroPad = this.zeroPad.bind(this);

        let date = new Date()
        this.state = {
            startDate: moment(date).format("DD/MM/YYYY"),
            endDate: moment(date).format("DD/MM/YYYY"),
            creditBalance: "0",
            startCreditDate: "",
            expiredCreditDate: "",
            creditUsed: "0",
            creditUsedText: "0",
            creditUsedRich: "0",
            deliverdRate: "0",
            deliverAmount: "0",
            deliveredTextAmount: "0",
            deliveredRichAmount: "0",
            deliveredTextMessage: "0",
            deliveredRichMessage: "0",
            unDeliveredAmount: "0",
            unDeliveredTextAmount: "0",
            unDeliveredRichAmount: "0",
            unDeliveredTextMessage: "0",
            unDeliveredRichmessage: "0",
            statusTotal: "0",
            statusDeliveredAmount: "0",
            statusUndeliveredAmount: "0",
            statusRejectAmount: "0",
            statusPendingAmount: "0",
            statusUnverifiedAmount: "0",
            statusDeliveredRate: "0",
            statusUndeliveredRate: "0",
            statusRejectRate: "0",
            statusPendingRate: "0",
            statusUnverifiedRate: "0",
            followlist: [],
            maxChart: 0,
            label: [],
            successAmount: [],
            failAmount: [],
            unverifiedAmount: [],
            pendingAmount: [],
            loading: false
        }
    }

    componentDidMount() {
        this.LineDashBoard();
        this.LineFollowData();
        this.LineMainChart();
    }

    //==== Request LineDashBoard ====
    LineDashBoard() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })

            fetch(urlapi + "api/LineDashBoard", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    dashboardlist: json,
                                    creditBalance: json.creditbalance,
                                    startCreditDate: json.startCreditDate,
                                    expiredCreditDate: json.expiredCreditDate,
                                    creditUsed: json.creditused.totalAmount,
                                    creditUsedText: json.creditused.textAmount,
                                    creditUsedRich: json.creditused.richAmount,
                                    deliverdRate: json.delivers.deliverdRate,
                                    deliverAmount: json.delivers.deliveredAmount,
                                    deliveredTextAmount: json.delivers.deliveredTextAmount,
                                    deliveredRichAmount: json.delivers.deliveredRichAmount,
                                    deliveredTextMessage: json.delivers.deliveredTextMessage,
                                    deliveredRichMessage: json.delivers.deliveredRichMessage,
                                    unDeliveredAmount: json.delivers.unDeliveredAmount,
                                    unDeliveredTextAmount: json.delivers.unDeliveredTextAmount,
                                    unDeliveredRichAmount: json.delivers.unDeliveredRichAmount,
                                    unDeliveredTextMessage: json.delivers.unDeliveredTextMessage,
                                    unDeliveredRichmessage: json.delivers.unDeliveredRichmessage,
                                });
                                this.setState({ loading: false })
                            }.bind(this)
                        );
                    } else {
                        this.setState({ loading: false })
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ loading: false })
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/login");
        }
    }

    //==== Request LineFollowData ====
    LineFollowData() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })

            fetch(urlapi + "api/LineFollowData", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    followlist: json.value

                                });
                                this.setState({ loading: false })
                            }.bind(this)
                        );
                    } else {
                        this.setState({ loading: false })
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ loading: false })
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/login");
        }
    }

    //==== Request LineMainChart ====
    LineMainChart() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })

            let req = JSON.stringify({
                startDate: this.state.startDate,
                endDate: this.state.endDate
            });
            fetch(urlapi + "api/LineMainChart", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    maxChart: json.maxChart,
                                    label: json.label,
                                    successAmount: json.values,
                                    failAmount: json.failAmount,
                                    unverifiedAmount: json.unverifiedAmount,
                                    pendingAmount: json.pendingAmount,
                                    statusTotal: json.sendstatus.statusTotal,
                                    statusDeliveredAmount: json.sendstatus.statusDelivered,
                                    statusUndeliveredAmount: json.sendstatus.statusUndelivered,
                                    statusRejectAmount: json.sendstatus.statusReject,
                                    statusPendingAmount: json.sendstatus.statusPending,
                                    statusUnverifiedAmount: json.sendstatus.statusUnverified,
                                    statusDeliveredRate: json.sendstatus.statusDeliveredRate,
                                    statusUndeliveredRate: json.sendstatus.statusUndeliveredRate,
                                    statusRejectRate: json.sendstatus.statusRejectRate,
                                    statusPendingRate: json.sendstatus.statusPendingRate,
                                    statusUnverifiedRate: json.sendstatus.statusUnverifiedRate
                                });
                                this.setState({ loading: false })
                            }.bind(this)
                        );
                    } else {
                        this.setState({ loading: false })
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ loading: false })
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/login");
        }
    }

    onChangedate(date, dateString) {
        this.setState({ startDate: dateString[0], endDate: dateString[1] });
    }

    onSearch() {
        this.LineMainChart()
    }

    onCreateExpiredate(datstr, ndays) {
        var dattmp = datstr.split('/').reverse().join('/');
        var nwdate = new Date(dattmp);
        nwdate.setDate(nwdate.getDate() + (ndays || 1));
        return [this.zeroPad(nwdate.getDate(), 10)
            , this.zeroPad(nwdate.getMonth() + 1, 10)
            , nwdate.getFullYear() + 1].join('/');
    }

    zeroPad(nr, base) {
        var len = (String(base).length - String(nr).length) + 1;
        return len > 0 ? new Array(len).join('0') + nr : nr;
    }


    render() {
        const mainChart = {
            labels: this.state.label,
            datasets: [
                {
                    label: 'Success',
                    backgroundColor: convertHex(brandInfo, 10),
                    borderColor: brandSuccess,
                    // pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    data: this.state.successAmount
                },
                {
                    label: 'Fail',
                    backgroundColor: 'transparent',
                    borderColor: brandDanger,
                    // pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    data: this.state.failAmount
                },
                {
                    label: 'Unverified',
                    backgroundColor: 'transparent',
                    borderColor: brandUnverified,
                    // pointHoverBackgroundColor: '#fff',
                    borderWidth: 3,
                    data: this.state.unverifiedAmount
                },
                {
                    label: 'Pending',
                    backgroundColor: 'transparent',
                    borderColor: brandPending,
                    // pointHoverBackgroundColor: '#fff',
                    borderWidth: 3,
                    data: this.state.pendingAmount
                }
            ]
        };
        const mainChartOpts = {
            responsive: true,
            tooltips: {
                mode: 'index',
                intersect: true,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        drawOnChartArea: false,
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 5,
                        stepSize: Math.ceil(this.state.maxChart / 5),
                        max: this.state.maxChart
                    }
                }]
            },
            elements: {
                point: {
                    radius: 0,
                    hitRadius: 10,
                    hoverRadius: 4,
                    hoverBorderWidth: 3,
                }
            }
        };
        const { RangePicker } = DatePicker;
        const dateFormat = 'DD/MM/YYYY';
        const dashboardProgressBar = [
            {
                name: 'Delivered',
                value: this.state.statusDeliveredRate,
                color: '#1bbc9b'
            },
            {
                name: 'Reject',
                value: this.state.statusRejectRate,
                color: '#e44b3b'
            },
            {
                name: 'Undelivered',
                value: this.state.statusUndeliveredRate,
                color: '#95a5a5'
            },
            {
                name: 'Unverified',
                value: this.state.statusUnverifiedRate,
                color: '#9A57B4'
            }
        ]
        const title = this.state.statusDeliveredRate == "0" && this.state.statusRejectRate == "0" &&
            this.state.statusUndeliveredRate == "0" && this.state.statusUnverifiedRate == "0" ?
            "0" : "100"

        return (
            <div>
                <PageHeader title="Dashboard">
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={4}></Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={20}>
                            {/* <Row gutter={16} type="flex" justify="start">
                                <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col>
                                <Col xs={24} sm={16} md={20} lg={10} xl={10} style={{ marginTop: '10px' }}>
                                    <RangePicker
                                        style={{ width: "100%" }}
                                        format={dateFormat}
                                        suffixIcon={<span className="fa fa-calendar-o" />}
                                        onChange={this.onChangedate}
                                        ranges={{
                                            Today: [moment().startOf('day'), moment().endOf('day')],
                                            'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                            'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                            'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                            'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                            'This month': [moment().startOf('month'), moment().endOf('month')]
                                        }}
                                    />
                                </Col>
                                <Col xs={24} sm={8} md={4} lg={4} xl={4} style={{ textAlign: 'center', marginTop: '10px' }}>
                                    <Button icon="search" style={{ marginRight: 8 }} onClick={this.onSearch}>
                                        Search
                                    </Button>
                                </Col>
                            </Row> */}

                        </Col>
                    </Row>
                </PageHeader>

                <div className="content">
                    <Spin spinning={this.state.loading}>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                                <Card4 title={this.state.creditBalance} detail={'Credit balance'} createdate={this.state.startCreditDate} expiredate={this.state.expiredCreditDate} />
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                                <Card5 title={this.state.deliverdRate + '%'} detail={'Delivery Rate'} deliveredTextMessage={this.state.deliveredTextMessage} Text={this.state.deliveredTextMessage + '%'} Rich={this.state.deliveredRichMessage + '%'} />

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                                <Card5 title={this.state.creditUsed} detail={'Total Credit'} deliveredTextMessage={this.state.deliveredTextMessage} Text={this.state.creditUsedText} Rich={this.state.creditUsedRich} />
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                                <Card className="card1" >
                                    <Row gutter={16} style={{ marginTop: 15 }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Row gutter={16} type="flex" justify="center">
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <LineDoughnut followlist={this.state.followlist} />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={4}></Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={20}>
                                <Row gutter={16} type="flex" justify="start">
                                    <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col>
                                    <Col xs={24} sm={16} md={20} lg={10} xl={10} style={{ marginTop: '10px' }}>
                                        <RangePicker
                                            style={{ width: "100%" }}
                                            format={dateFormat}
                                            suffixIcon={<span className="fa fa-calendar-o" />}
                                            onChange={this.onChangedate}
                                            defaultValue={[moment(), moment()]}
                                            ranges={{
                                                Today: [moment().startOf('day'), moment().endOf('day')],
                                                'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                                'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                                'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                                'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                                'This month': [moment().startOf('month'), moment().endOf('month')]
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} sm={8} md={4} lg={4} xl={4} style={{ textAlign: 'center', marginTop: '10px' }}>
                                        <Button icon="search"
                                            style={{ marginRight: 8 }}
                                            onClick={this.onSearch}
                                            disabled={!this.state.startDate || !this.state.endDate}
                                        >
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card>
                                    <CardBody>
                                        <Row gutter={16}>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <h5 className="card-title clearfix mb-0">Traffic</h5>
                                                <div className="chart-wrapper" style={{ height: 300 + 'px', marginTop: 40 + 'px', textAlign: 'center' }}>
                                                    <Line data={mainChart} options={mainChartOpts} height={300} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <div className="text-muted" style={{ textAlign: 'center', marginBottom: '-10px', marginTop: '10px' }}>Success</div>
                                                <strong id="lns-val"></strong>
                                                <div className="progress progress-xs mt-2">
                                                    <div className="progress-bar bg-success" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <div className="text-muted" style={{ textAlign: 'center', marginBottom: '-10px', marginTop: '10px' }}>Fail</div>
                                                <strong id="lns-val"></strong>
                                                <div className="progress progress-xs mt-2">
                                                    <div className="progress-bar bg-danger" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <div className="text-muted" style={{ textAlign: 'center', marginBottom: '-10px', marginTop: '10px' }}>Pending</div>
                                                <strong id="lns-val"></strong>
                                                <div className="progress progress-xs mt-2">
                                                    <div className="progress-bar bg-warning" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <div className="text-muted" style={{ textAlign: 'center', marginBottom: '-10px', marginTop: '10px' }}>Unverified</div>
                                                <strong id="lns-val"></strong>
                                                <div className="progress progress-xs mt-2">
                                                    <div className="progress-bar" role="progressbar" style={{ width: '100%', backgroundColor: 'black' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Card2 img={'img/vendors/Pending.png'} title={this.state.statusPendingAmount} detail={'Pending'} />
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Card2 img={'img/vendors/Unverified.jpg'} title={this.state.statusUnverifiedAmount} detail={'Unverified'} />
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Card2 img={'img/vendors/Delivered.png'} title={this.state.statusDeliveredAmount} detail={'Delivered'} />
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Card2 img={'img/vendors/Reject.png'} title={this.state.statusRejectAmount} detail={'Reject'} />
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Card2 img={'img/vendors/Undelivered.png'} title={this.state.statusUndeliveredAmount} detail={'Undelivered'} />
                            </Col>
                        </Row>
                        {/* <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Card>
                                <CardBody>
                                    <h5 className="card-title clearfix mb-0">Delivery rate by status</h5>
                                    <div className="chart-wrapper">
                                        <MultiColorProgressBar readings={dashboardProgressBar} title={title} />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> */}
                    </Spin>
                </div>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js